import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchCenters,
  fetchEvents,
  fetchtApplicationDetails,
  getAllRankLists,
  handleAddEvent,
  handleUpdateCenter,
  locationMasters,
} from "../../redux/actions/grievanceActions1";

const UpdateCenterList = ({ onClose, show, center }) => {
  console.log(center, "center");

  // Separate state for each field
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Center basic info
  const [unitCenterId, setUnitCenterId] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");

  // President details
  const [preRankId, setPreRankId] = useState("");
  const [preName, setPreName] = useState("");
  const [preMobileNo, setPreMobileNo] = useState("");
  const [preWefDate, setPreWefDate] = useState("");
  const [preLastUnitServed, setPreLastUnitServed] = useState("");
  const [preTradeName, setPreTradeName] = useState("");
  const [prePhoto, setPrePhoto] = useState("");

  // Secretary details
  const [secRankId, setSecRankId] = useState("");
  const [secName, setSecName] = useState("");
  const [secMobileNo, setSecMobileNo] = useState("");
  const [secWefDate, setSecWefDate] = useState("");
  const [secLastUnitServed, setSecLastUnitServed] = useState("");
  const [secTradeName, setSecTradeName] = useState("");
  const [secPhoto, setSecPhoto] = useState("");

  // Error state
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { locationMaster, getAllRankList } = useSelector(
    (state) => state.grievances
  );

  useEffect(() => {
    dispatch(getAllRankLists());
  }, [dispatch]);

  const convertDateFormat = (dateString) => {
    if (!dateString || dateString === "N/A") return "";

    if (dateString.includes("-")) return dateString;

    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  // Update your useEffect to use the helper function
  useEffect(() => {
    if (center) {
      setUnitCenterId(center.id || "");
      setAddress(center.location || "");
      setDescription(center.remarks || "");
      setPreName(center.presidentName || "");
      setPreMobileNo(center.presidentMobile1 || "");

      // Convert dates to proper format
      setPreWefDate(convertDateFormat(center.PRE_WEF_DATE));
      setSecWefDate(convertDateFormat(center.SEC_WEF_DATE));

      setPreLastUnitServed(center.PRE_LAST_UNIT_SERVED || "");
      setPreTradeName(center.PRE_TRADE_NAME || "");
      setSecLastUnitServed(center.SEC_LAST_UNIT_SERVED || "");
      setSecTradeName(center.SEC_TRADE_NAME || "");
      setSecName(center.secretaryName || "");
      setSecMobileNo(center.secretaryMobile1 || "");

      // Extract rank from presidentRank and secretaryRank if needed
      setPreRankId(center.presidentRank || "");
      setSecRankId(center.secretaryRank || "");
    }
  }, [center]);

  // Validation function
  const validateForm = () => {
    const newErrors = {};

    if (!unitCenterId.trim())
      newErrors.unitCenterId = "Unit Center ID is required";
    if (!address.trim()) newErrors.address = "Address is required";
    if (!description.trim()) newErrors.description = "Description is required";

    // President validation
    if (!preRankId.trim()) newErrors.preRankId = "President rank is required";
    if (!preName.trim()) newErrors.preName = "President name is required";
    if (!preMobileNo.trim())
      newErrors.preMobileNo = "President mobile number is required";
    if (!preWefDate) newErrors.preWefDate = "President WEF date is required";
    if (!preLastUnitServed.trim())
      newErrors.preLastUnitServed = "President last unit served is required";
    if (!preTradeName.trim())
      newErrors.preTradeName = "President trade name is required";

    // Secretary validation
    if (!secRankId.trim()) newErrors.secRankId = "Secretary rank is required";
    if (!secName.trim()) newErrors.secName = "Secretary name is required";
    if (!secMobileNo.trim())
      newErrors.secMobileNo = "Secretary mobile number is required";
    if (!secWefDate) newErrors.secWefDate = "Secretary WEF date is required";
    if (!secLastUnitServed.trim())
      newErrors.secLastUnitServed = "Secretary last unit served is required";
    if (!secTradeName.trim())
      newErrors.secTradeName = "Secretary trade name is required";

    // Mobile number validation
    const mobilePattern = /^[6-9]\d{9}$/;
    if (preMobileNo && !mobilePattern.test(preMobileNo)) {
      newErrors.preMobileNo = "Please enter a valid mobile number";
    }
    if (secMobileNo && !mobilePattern.test(secMobileNo)) {
      newErrors.secMobileNo = "Please enter a valid mobile number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdateCenters = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const centerData = {
        eventID: center?.id || "",
        addInfo: {
          unit_center_id: unitCenterId.trim(),
          address: address.trim(),
          description: description.trim(),
          pre_rank_id: preRankId.trim(),
          pre_name: preName.trim(),
          pre_mobile_no: preMobileNo.trim(),
          pre_wef_date: preWefDate,
          pre_last_unit_served: preLastUnitServed.trim(),
          pre_trade_name: preTradeName.trim(),
          pre_photo: prePhoto.trim() || "",
          sec_rank_id: secRankId.trim(),
          sec_name: secName.trim(),
          sec_mobile_no: secMobileNo.trim(),
          sec_wef_date: secWefDate,
          sec_last_unit_served: secLastUnitServed.trim(),
          sec_trade_name: secTradeName.trim(),
          sec_photo: secPhoto.trim() || "",
        },
      };

      console.log("Sending center data:", centerData);

      const res = await dispatch(handleUpdateCenter(centerData));
      if (res.rCode == 0) {
        alert(res.rMessage || "Center updated successfully!");
        dispatch(fetchCenters());
        resetForm();
        onClose();
        await dispatch(fetchEvents());
      } else {
        alert(res.rMessage || "Error in updating center!");
      }
    } catch (error) {
      console.error("Error updating center:", error);
      alert("Error updating center. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setUnitCenterId("");
    setAddress("");
    setDescription("");
    setPreRankId("");
    setPreName("");
    setPreMobileNo("");
    setPreWefDate("");
    setPreLastUnitServed("");
    setPreTradeName("");
    setPrePhoto("");
    setSecRankId("");
    setSecName("");
    setSecMobileNo("");
    setSecWefDate("");
    setSecLastUnitServed("");
    setSecTradeName("");
    setSecPhoto("");
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="UpdateCenterModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="updateCenter-exampleModalLabel"
            >
              Update ARESA Center
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Center Basic Information */}

            {/* President Details */}
            <div className="row mb-4">
              <div className="col-12">
                <h6 className="text-primary mb-3">President Details</h6>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-rank-id" className="form-label">
                  Rank <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${
                    errors.preRankId ? "is-invalid" : ""
                  }`}
                  id="pre-rank-id"
                  value={preRankId}
                  onChange={(e) => setPreRankId(e.target.value)}
                >
                  <option value="">Select Rank</option>
                  {getAllRankList && getAllRankList.length > 0 ? (
                    getAllRankList.map((rank) => (
                      <option key={rank.RANK_ID} value={rank.RANK_ID}>
                        {rank.RANK_NAME}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      Loading ranks...
                    </option>
                  )}
                </select>
                {errors.preRankId && (
                  <div className="invalid-feedback">{errors.preRankId}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-name" className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.preName ? "is-invalid" : ""
                  }`}
                  id="pre-name"
                  placeholder="Enter president name"
                  value={preName}
                  onChange={(e) => setPreName(e.target.value)}
                />
                {errors.preName && (
                  <div className="invalid-feedback">{errors.preName}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-mobile-no" className="form-label">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  className={`form-control ${
                    errors.preMobileNo ? "is-invalid" : ""
                  }`}
                  id="pre-mobile-no"
                  placeholder="Enter mobile number"
                  value={preMobileNo}
                  onChange={(e) => setPreMobileNo(e.target.value)}
                />
                {errors.preMobileNo && (
                  <div className="invalid-feedback">{errors.preMobileNo}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-wef-date" className="form-label">
                  WEF Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className={`form-control ${
                    errors.preWefDate ? "is-invalid" : ""
                  }`}
                  id="pre-wef-date"
                  value={preWefDate}
                  onChange={(e) => setPreWefDate(e.target.value)}
                />
                {errors.preWefDate && (
                  <div className="invalid-feedback">{errors.preWefDate}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-last-unit-served" className="form-label">
                  Last Unit Served <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.preLastUnitServed ? "is-invalid" : ""
                  }`}
                  id="pre-last-unit-served"
                  placeholder="Enter last unit served"
                  value={preLastUnitServed}
                  onChange={(e) => setPreLastUnitServed(e.target.value)}
                />
                {errors.preLastUnitServed && (
                  <div className="invalid-feedback">
                    {errors.preLastUnitServed}
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="pre-trade-name" className="form-label">
                  Trade Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.preTradeName ? "is-invalid" : ""
                  }`}
                  id="pre-trade-name"
                  placeholder="Enter trade name"
                  value={preTradeName}
                  onChange={(e) => setPreTradeName(e.target.value)}
                />
                {errors.preTradeName && (
                  <div className="invalid-feedback">{errors.preTradeName}</div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="pre-photo" className="form-label">
                  Photo URL
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="pre-photo"
                  placeholder="Enter photo URL (optional)"
                  value={prePhoto}
                  onChange={(e) => setPrePhoto(e.target.value)}
                />
              </div>
            </div>

            {/* Secretary Details */}
            <div className="row mb-4">
              <div className="col-12">
                <h6 className="text-primary mb-3">Secretary Details</h6>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-rank-id" className="form-label">
                  Rank <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${
                    errors.secRankId ? "is-invalid" : ""
                  }`}
                  id="sec-rank-id"
                  value={secRankId}
                  onChange={(e) => setSecRankId(e.target.value)}
                >
                  <option value="">Select Rank</option>
                  {getAllRankList && getAllRankList.length > 0 ? (
                    getAllRankList.map((rank) => (
                      <option key={rank.RANK_ID} value={rank.RANK_ID}>
                        {rank.RANK_NAME}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      Loading ranks...
                    </option>
                  )}
                </select>
                {errors.secRankId && (
                  <div className="invalid-feedback">{errors.secRankId}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-name" className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.secName ? "is-invalid" : ""
                  }`}
                  id="sec-name"
                  placeholder="Enter secretary name"
                  value={secName}
                  onChange={(e) => setSecName(e.target.value)}
                />
                {errors.secName && (
                  <div className="invalid-feedback">{errors.secName}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-mobile-no" className="form-label">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  className={`form-control ${
                    errors.secMobileNo ? "is-invalid" : ""
                  }`}
                  id="sec-mobile-no"
                  placeholder="Enter mobile number"
                  value={secMobileNo}
                  onChange={(e) => setSecMobileNo(e.target.value)}
                />
                {errors.secMobileNo && (
                  <div className="invalid-feedback">{errors.secMobileNo}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-wef-date" className="form-label">
                  WEF Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className={`form-control ${
                    errors.secWefDate ? "is-invalid" : ""
                  }`}
                  id="sec-wef-date"
                  value={secWefDate}
                  onChange={(e) => setSecWefDate(e.target.value)}
                />
                {errors.secWefDate && (
                  <div className="invalid-feedback">{errors.secWefDate}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-last-unit-served" className="form-label">
                  Last Unit Served <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.secLastUnitServed ? "is-invalid" : ""
                  }`}
                  id="sec-last-unit-served"
                  placeholder="Enter last unit served"
                  value={secLastUnitServed}
                  onChange={(e) => setSecLastUnitServed(e.target.value)}
                />
                {errors.secLastUnitServed && (
                  <div className="invalid-feedback">
                    {errors.secLastUnitServed}
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="sec-trade-name" className="form-label">
                  Trade Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.secTradeName ? "is-invalid" : ""
                  }`}
                  id="sec-trade-name"
                  placeholder="Enter trade name"
                  value={secTradeName}
                  onChange={(e) => setSecTradeName(e.target.value)}
                />
                {errors.secTradeName && (
                  <div className="invalid-feedback">{errors.secTradeName}</div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="sec-photo" className="form-label">
                  Photo URL
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="sec-photo"
                  placeholder="Enter photo URL (optional)"
                  value={secPhoto}
                  onChange={(e) => setSecPhoto(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-8 mb-3">
                <label htmlFor="address" className="form-label">
                  Address <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.address ? "is-invalid" : ""
                  }`}
                  id="address"
                  placeholder="Enter center address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                {errors.address && (
                  <div className="invalid-feedback">{errors.address}</div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="description" className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
                <textarea
                  className={`form-control ${
                    errors.description ? "is-invalid" : ""
                  }`}
                  id="description"
                  rows="3"
                  placeholder="Enter center description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
                {errors.description && (
                  <div className="invalid-feedback">{errors.description}</div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleUpdateCenters}
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                "Update Center"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCenterList;
